import { render, staticRenderFns } from "./topbar-default.vue?vue&type=template&id=e6681270&scoped=true&"
import script from "./topbar-default.vue?vue&type=script&lang=js&"
export * from "./topbar-default.vue?vue&type=script&lang=js&"
import style0 from "./topbar-default.vue?vue&type=style&index=0&id=e6681270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6681270",
  null
  
)

export default component.exports